export const foods = {
  coffee: [
    {
      id: 0,
      name: "Cappuccino",
      description:
        "A cappuccino is an espresso-based coffee drink that is traditionally prepared with steamed milk foam.",
      ingredients: ["Steamed milk foam", "Double espresso", "Hot milk"],
      spicy: false,
      vegetarian: false,
      price: 7,
      image: "https://i.postimg.cc/qM56s2sP/cappuccino.jpg",
    },
    {
      id: 1,
      name: "Latte",
      description:
        "Caffè latte, often shortened to just latte in English, is a coffee drink of Italian origin made with espresso and steamed milk",
      ingredients: ["Coffee", "Milk", "Espresso"],
      spicy: false,
      vegetarian: false,
      price: 9.2,
      image: "https://i.postimg.cc/Fzfd8RmW/latte.jpg",
    },
    {
      id: 2,
      name: "Espresso",
      description:
        "Espresso is a coffee-brewing method of Italian origin, in which a small amount of nearly boiling water is forced under 9–10 bars of pressure through finely-ground coffee beans. Espresso can be made with a wide variety of coffee beans and roast degrees.",
      ingredients: ["Ground coffee beans", "Nearly boiling water"],
      spicy: false,
      vegetarian: false,
      price: 5,
      image:
        "https://i.postimg.cc/bNFJ4bvq/alessandro-crosato-1yc-Qd-I4pl-O8-unsplash.jpg",
    },
    {
      id: 3,
      name: "Water",
      description: "Dorna 0.5L",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4.5,
      image: "https://i.imgur.com/yYuuaL1.jpg",
    },
    {
      id: 4,
      name: "Sparkling water",
      description: "Dorna 0.5L",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4.5,
      image: "https://i.imgur.com/0nyJk19.jpg",
    },
  ],
  pizza: [
    {
      id: 6,
      name: "Margherita",
      description: "",
      ingredients: ["tomato sauce", "mozzarella"],
      spicy: false,
      vegetarian: true,
      price: 17.0,
      image: "https://i.imgur.com/8B8YLOo.jpg",
    },
    {
      id: 7,
      name: "Pepperoni",
      description: "",
      ingredients: ["tomato sauce", "mozzarella", "double pepperoni"],
      spicy: false,
      vegetarian: false,
      price: 20.0,
      image: "https://i.imgur.com/OHHctnf.jpg",
    },
    {
      id: 8,
      name: "Rome",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "ham",
        "mushrooms",
        "beef cubes",
      ],
      spicy: false,
      vegetarian: false,
      price: 25.75,
      image: "https://i.imgur.com/3ZTwCfz.png",
    },
    {
      id: 9,
      name: "American Spicy",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "pepperoni",
        "tomatoes",
        "green pepper",
        "red onion",
        "jalapenos",
        "Samourai sauce",
      ],
      spicy: true,
      vegetarian: false,
      price: 30.25,
      image: "https://i.imgur.com/dyoOLCO.png",
    },
    {
      id: 10,
      name: "Quattro Stagioni",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "ham",
        "pepperoni",
        "mushrooms",
        "green pepper",
      ],
      spicy: false,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/wOEuXuV.jpg",
    },
    {
      id: 11,
      name: "Pork & Feta",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "feta cheese",
        "ham",
        "pork cubes",
        "red onion",
      ],
      spicy: false,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/48Zw4K3.png",
    },
    {
      id: 12,
      name: "Quattro Formaggi",
      description: "",
      ingredients: [
        "mozzarella",
        "cheddar cheese",
        "emmentaler",
        "blue cheese",
        "oregano",
      ],
      spicy: false,
      vegetarian: true,
      price: 35.15,
      image: "https://i.imgur.com/MDrTvkI.jpg",
    },
    {
      id: 13,
      name: "Carnivora",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "chicken breast",
        "beef cubes",
        "pepperoni",
        "bacon",
      ],
      spicy: false,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/0vPtSSO.png",
    },
    {
      id: 14,
      name: "Louisiana Chicken",
      description: "",
      ingredients: [
        "marinated chicken",
        "TABASCO spicy sauce",
        "red pepper sauce",
        "blue cheese",
        "green pepper",
        "red onion",
      ],
      spicy: true,
      vegetarian: false,
      price: 20.0,
      image: "https://i.imgur.com/lZtwJgy.png",
    },
    {
      id: 15,
      name: "Honey Mustard Chicken",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "marinated chicken in Honey Mustard sauce",
        "cheddar cheese",
        "red onion",
      ],
      spicy: false,
      vegetarian: false,
      price: 19.8,
      image: "https://i.imgur.com/SoZu61g.png",
    },
    {
      id: 16,
      name: "Hawaiian",
      description: "",
      ingredients: [
        "mozzarella",
        "sweet chilli sauce",
        "pepperoni",
        "pineapple",
        "jalapenos",
        "red onion",
      ],
      spicy: true,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/mqTgvgl.png",
    },
    {
      id: 17,
      name: "Classic",
      description: "",
      ingredients: ["tomato sauce", "mozzarella", "ham", "mushrooms", "olives"],
      spicy: false,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/k6IGrUd.png",
    },
    {
      id: 12,
      name: "Pastrami",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "pastrami",
        "salty cheese",
        "baked green pepper",
        "red onion",
      ],
      spicy: false,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/yOe5RtC.png",
    },
    {
      id: 13,
      name: "Hot Pastrami",
      description: "",
      ingredients: [
        "Honey Mustard sauce",
        "mozzarella",
        "pastrami",
        "sausages",
        "chilli pepper",
        "red onion",
      ],
      spicy: true,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/ipMA5LP.png",
    },
    {
      id: 14,
      name: "Country",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "bacon",
        "corn",
        "onion",
        "mushrooms",
      ],
      spicy: false,
      vegetarian: false,
      price: 27.25,
      image: "https://i.imgur.com/E67Xf8Y.png",
    },
    {
      id: 15,
      name: "Hot Cheese",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "cheddar cheese",
        "salty cheese",
        "tomatoes",
        "chilli pepper",
        "oregano",
      ],
      spicy: true,
      vegetarian: true,
      price: 27.25,
      image: "https://i.imgur.com/v4sa2cA.png",
    },
    {
      id: 16,
      name: "Ocean",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "tuna",
        "corn",
        "onion",
        "olives",
      ],
      spicy: false,
      vegetarian: false,
      price: 30,
      image: "https://i.imgur.com/w5IQ2rX.png",
    },
    {
      id: 17,
      name: "BBQ",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "BBQ sauce",
        "onion",
        "corn",
        "bacon",
        "mushrooms",
        "sausages",
      ],
      spicy: false,
      vegetarian: false,
      price: 28.5,
      image: "https://i.imgur.com/znqS9KD.png",
    },
    {
      id: 18,
      name: "Mexicana",
      description: "",
      ingredients: [
        "tomato sauce",
        "mozzarella",
        "salsa sauce",
        "pepperoni",
        "corn",
        "onion",
        "jalapenos",
        "tortilla chips",
      ],
      spicy: true,
      vegetarian: false,
      price: 28.5,
      image: "https://i.imgur.com/cYpO8RT.png",
    },
  ],
  pasta: [
    {
      id: 0,
      name: "Bolognese",
      description: "",
      ingredients: ["penne", "ragu sauce", "beef cubes", "mozzarella"],
      spicy: false,
      vegetarian: false,
      price: 28.0,
      image: "https://i.imgur.com/IXDJ52k.png",
    },
    {
      id: 1,
      name: "Carbonara",
      description: "",
      ingredients: [
        "penne",
        "white cream and garlic sauce",
        "bacon",
        "parmesan",
      ],
      spicy: false,
      vegetarian: true,
      price: 28.0,
      image: "https://i.imgur.com/3jKSuUu.png",
    },
  ],
  salads: [
    {
      id: 0,
      name: "Caesar",
      description: "",
      ingredients: [
        "chicken breast",
        "bacon",
        "parmesan",
        "cherry tomatoes",
        "croutons",
        "lettuce",
        "beetroot",
        "sauce of your choice",
      ],
      spicy: false,
      vegetarian: false,
      price: 20,
      image: "https://i.imgur.com/QWXH2NC.png",
    },
    {
      id: 1,
      name: "Greek",
      description: "",
      ingredients: [
        "feta cheese",
        "green olives",
        "cherry tomatoes",
        "cucumbers",
        "red onion",
        "red pepper",
        "oregano",
        "lettuce",
        "beetroot",
        "sauce of your choice",
      ],
      spicy: false,
      vegetarian: true,
      price: 20,
      image: "https://i.imgur.com/qChqf83.png",
    },
    {
      id: 2,
      name: "Tuna",
      description: "",
      ingredients: [
        "tuna",
        "green olives",
        "corn",
        "red pepper",
        "red onion",
        "lettuce",
        "beetroot",
        "sauce of your choice",
      ],
      spicy: false,
      vegetarian: false,
      price: 20,
      image: "https://i.imgur.com/Ph0IjrX.png",
    },
  ],
  dessert: [
    {
      id: 0,
      name: "Brownie",
      description: "A delicious cake with chocolate and hazelnuts",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 15,
      image: "https://i.imgur.com/7WbfaDN.png",
    },
    {
      id: 1,
      name: "Chocolate Tortilla",
      description: "Tortilla filled with chocolate cream",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 12,
      image: "https://i.imgur.com/Mgsc3IZ.png",
    },
    {
      id: 2,
      name: "Apple Pie",
      description: "Hot pie with apple and cinnamon",
      ingredients: [],
      spicy: false,
      vegetarian: true,
      price: 15,
      image: "https://i.imgur.com/OWIVhWX.png",
    },
    {
      id: 3,
      name: "Cheesecake",
      description: "Cheesecake with berries topping",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 15,
      image: "https://i.imgur.com/AsldA7x.png",
    },
  ],
  drinks: [
    {
      id: 0,
      name: "Coca Cola",
      description: "Coca Cola 330ml",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 5,
      image: "https://i.imgur.com/nJ6LeWv.png",
    },
    {
      id: 1,
      name: "Fanta",
      description: "Fanta 330ml",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 5,
      image: "https://i.imgur.com/1WDkfme.png",
    },
    {
      id: 2,
      name: "Sprite",
      description: "Sprite 330ml",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 5,
      image: "https://i.imgur.com/qP4Nx1x.jpg",
    },
    {
      id: 3,
      name: "Water",
      description: "Dorna 0.5L",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4.5,
      image: "https://i.imgur.com/yYuuaL1.jpg",
    },
    {
      id: 4,
      name: "Sparkling water",
      description: "Dorna 0.5L",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4.5,
      image: "https://i.imgur.com/0nyJk19.jpg",
    },
    {
      id: 5,
      name: "Fuzetea",
      description: "Fuzetea 0.5L Peach or Lemon",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 5,
      image: "https://i.imgur.com/dsHumXE.jpg",
    },
  ],
  sauces: [
    {
      id: 0,
      name: "BBQ",
      description: "",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/k5Dg7hZ.png",
    },
    {
      id: 1,
      name: "Pizza",
      description: "",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/k5Dg7hZ.png",
    },
    {
      id: 2,
      name: "Salsa",
      description: "",
      ingredients: [],
      spicy: true,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/k5Dg7hZ.png",
    },
    {
      id: 3,
      name: "Sweet Chilli",
      description: "",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/k5Dg7hZ.png",
    },
    {
      id: 4,
      name: "Spicy TABASCO",
      description: "",
      ingredients: [],
      spicy: true,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/k5Dg7hZ.png",
    },
    {
      id: 5,
      name: "Mayonnaise",
      description: "",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/OmejA2J.png",
    },
    {
      id: 6,
      name: "Ketchup",
      description: "",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/k5Dg7hZ.png",
    },
    {
      id: 7,
      name: "Garlic sauce",
      description: "",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 4,
      image: "https://i.imgur.com/OmejA2J.png",
    },
  ],
  sides: [
    {
      id: 0,
      name: "Wedges",
      description: "Baked potatoes, slightly spicy",
      ingredients: [],
      spicy: false,
      vegetarian: true,
      price: 6,
      image: "https://i.imgur.com/sxP6sJt.png",
    },
    {
      id: 1,
      name: "Onion rings",
      description: "Fried onion rings",
      ingredients: [],
      spicy: false,
      vegetarian: true,
      price: 6,
      image: "https://i.imgur.com/i3Jintb.png",
    },
    {
      id: 2,
      name: "Coleslaw",
      description: "Cabbage salad, carrots and dressing",
      ingredients: [],
      spicy: false,
      vegetarian: false,
      price: 10,
      image: "https://i.imgur.com/HNX30U9.png",
    },
  ],
  others: [
    {
      id: "52767",
      name: "Bakewell tart",
      description:
        "To make the pastry, measure the flour into a bowl and rub in the butter with your fingertips until the mixture resembles fine breadcrumbs. Add the water, mixing to form a soft dough.\r\nRoll out the dough on a lightly floured work surface and use to line a 20cm/8in flan tin. Leave in the fridge to chill for 30 minutes.\r\nPreheat the oven to 200C/400F/Gas 6 (180C fan).\r\nLine the pastry case with foil and fill with baking beans. Bake blind for about 15 minutes, then remove the beans and foil and cook for a further five minutes to dry out the base.\r\nFor the filing, spread the base of the flan generously with raspberry jam.\r\nMelt the butter in a pan, take off the heat and then stir in the sugar. Add ground almonds, egg and almond extract. Pour into the flan tin and sprinkle over the flaked almonds.\r\nBake for about 35 minutes. If the almonds seem to be browning too quickly, cover the tart loosely with foil to prevent them burning.",
      ingredients: [
        "plain flour",
        "chilled butter",
        "cold water",
        "raspberry jam",
        "butter",
        "caster sugar",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.24",
      image:
        "https://www.themealdb.com/images/media/meals/wyrqqq1468233628.jpg",
    },
    {
      id: "52792",
      name: "Bread and Butter Pudding",
      description:
        "Grease a 1 litre/2 pint pie dish with butter.\r\nCut the crusts off the bread. Spread each slice with on one side with butter, then cut into triangles.\r\nArrange a layer of bread, buttered-side up, in the bottom of the dish, then add a layer of sultanas. Sprinkle with a little cinnamon, then repeat the layers of bread and sultanas, sprinkling with cinnamon, until you have used up all of the bread. Finish with a layer of bread, then set aside.\r\nGently warm the milk and cream in a pan over a low heat to scalding point. Don't let it boil.\r\nCrack the eggs into a bowl, add three quarters of the sugar and lightly whisk until pale.\r\nAdd the warm milk and cream mixture and stir well, then strain the custard into a bowl.\r\nPour the custard over the prepared bread layers and sprinkle with nutmeg and the remaining sugar and leave to stand for 30 minutes.\r\nPreheat the oven to 180C/355F/Gas 4.\r\nPlace the dish into the oven and bake for 30-40 minutes, or until the custard has set and the top is golden-brown.",
      ingredients: [
        "butter",
        "bread",
        "sultanas",
        "cinnamon",
        "milk",
        "double cream",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.99",
      image:
        "https://www.themealdb.com/images/media/meals/xqwwpy1483908697.jpg",
    },
    {
      id: "52803",
      name: "Beef Wellington",
      description:
        "Put the mushrooms into a food processor with some seasoning and pulse to a rough paste. Scrape the paste into a pan and cook over a high heat for about 10 mins, tossing frequently, to cook out the moisture from the mushrooms. Spread out on a plate to cool.\r\nHeat in a frying pan and add a little olive oil. Season the beef and sear in the hot pan for 30 secs only on each side. (You don't want to cook it at this stage, just colour it). Remove the beef from the pan and leave to cool, then brush all over with the mustard.\r\nLay a sheet of cling film on a work surface and arrange the Parma ham slices on it, in slightly overlapping rows. With a palette knife, spread the mushroom paste over the ham, then place the seared beef fillet in the middle. Keeping a tight hold of the cling film from the edge, neatly roll the Parma ham and mushrooms around the beef to form a tight barrel shape. Twist the ends of the cling film to secure. Chill for 15-20 mins to allow the beef to set and keep its shape.\r\nRoll out the puff pastry on a floured surface to a large rectangle, the thickness of a £1 coin. Remove the cling film from the beef, then lay in the centre. Brush the surrounding pastry with egg yolk. Fold the ends over, the wrap the pastry around the beef, cutting off any excess. Turn over, so the seam is underneath, and place on a baking sheet. Brush over all the pastry with egg and chill for about 15 mins to let the pastry rest.\r\nHeat the oven to 200C, 400F, gas 6.\r\nLightly score the pastry at 1cm intervals and glaze again with beaten egg yolk. Bake for 20 minutes, then lower the oven setting to 180C, 350F, gas 4 and cook for another 15 mins. Allow to rest for 10-15 mins before slicing and serving with the side dishes of your choice. The beef should still be pink in the centre when you serve it.",
      ingredients: [
        "mushrooms",
        "English Mustard",
        "Olive Oil",
        "Beef Fillet",
        "Parma ham",
        "Puff Pastry",
      ],
      spicy: false,
      vegetarian: true,
      price: "11.00",
      image:
        "https://www.themealdb.com/images/media/meals/vvpprx1487325699.jpg",
    },
    {
      id: "52807",
      name: "Baingan Bharta",
      description:
        "Rinse the baingan (eggplant or aubergine) in water. Pat dry with a kitchen napkin. Apply some oil all over and\r\nkeep it for roasting on an open flame. You can also grill the baingan or roast in the oven. But then you won't get\r\nthe smoky flavor of the baingan. Keep the eggplant turning after a 2 to 3 minutes on the flame, so that its evenly\r\ncooked. You could also embed some garlic cloves in the baingan and then roast it.\r\n2. Roast the aubergine till its completely cooked and tender. With a knife check the doneness. The knife should slid\r\neasily in aubergines without any resistance. Remove the baingan and immerse in a bowl of water till it cools\r\ndown.\r\n3. You can also do the dhungar technique of infusing charcoal smoky flavor in the baingan. This is an optional step.\r\nUse natural charcoal for this method. Heat a small piece of charcoal on flame till it becomes smoking hot and red.\r\n4. Make small cuts on the baingan with a knife. Place the red hot charcoal in the same plate where the roasted\r\naubergine is kept. Add a few drops of oil on the charcoal. The charcoal would begin to smoke.\r\n5. As soon as smoke begins to release from the charcoal, cover the entire plate tightly with a large bowl. Allow the\r\ncharcoal smoke to get infused for 1 to 2 minutes. The more you do, the more smoky the baingan bharta will\r\nbecome. I just keep for a minute. Alternatively, you can also do this dhungar method once the baingan bharta is\r\ncooked, just like the way we do for Dal Tadka.\r\n6. Peel the skin from the roasted and smoked eggplant.\r\n7. Chop the cooked eggplant finely or you can even mash it.\r\n8. In a kadai or pan, heat oil. Then add finely chopped onions and garlic.\r\n9. Saute the onions till translucent. Don't brown them.\r\n10. Add chopped green chilies and saute for a minute.\r\n11. Add the chopped tomatoes and mix it well.\r\n12. Bhuno (saute) the tomatoes till the oil starts separating from the mixture.\r\n13. Now add the red chili powder. Stir and mix well.\r\n14. Add the chopped cooked baingan.\r\n15. Stir and mix the chopped baingan very well with the onion­tomato masala mixture.\r\n16. Season with salt. Stir and saute for some more 4 to 5 minutes more.\r\n17. Finally stir in the coriander leaves with the baingan bharta or garnish it with them. Serve Baingan Bharta with\r\nphulkas, rotis or chapatis. It goes well even with bread, toasted or grilled bread and plain rice or jeera rice.",
      ingredients: [
        "Aubergine",
        "Onion",
        "Tomatoes",
        "Garlic",
        "Green Chili",
        "Red Chili Powder",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.91",
      image:
        "https://www.themealdb.com/images/media/meals/urtpqw1487341253.jpg",
    },
    {
      id: "52812",
      name: "Beef Brisket Pot Roast",
      description:
        '1 Prepare the brisket for cooking: On one side of the brisket there should be a layer of fat, which you want. If there are any large chunks of fat, cut them off and discard them. Large pieces of fat will not be able to render out completely.\r\nUsing a sharp knife, score the fat in parallel lines, about 3/4-inch apart. Slice through the fat, not the beef. Repeat in the opposite direction to make a cross-hatch pattern.\r\nSalt the brisket well and let it sit at room temperature for 30 minutes.\r\n \r\n2 Sear the brisket: You\'ll need an oven-proof, thick-bottomed pot with a cover, or Dutch oven, that is just wide enough to hold the brisket roast with a little room for the onions.\r\nPat the brisket dry and place it, fatty side down, into the pot and place it on medium high heat. Cook for 5-8 minutes, lightly sizzling, until the fat side is nicely browned. (If the roast seems to be cooking too fast, turn the heat down to medium. You want a steady sizzle, not a raging sear.)\r\nTurn the brisket over and cook for a few minutes more to brown the other side.\r\n\r\n3 Sauté the onions and garlic: When the brisket has browned, remove it from the pot and set aside. There should be a couple tablespoons of fat rendered in the pot, if not, add some olive oil.\r\nAdd the chopped onions and increase the heat to high. Sprinkle a little salt on the onions. Sauté, stirring often, until the onions are lightly browned, 5-8 minutes. Stir in the garlic and cook 1-2 more minutes.\r\n \r\n4 Return brisket to pot, add herbs, stock, bring to simmer, cover, cook in oven: Preheat the oven to 300°F. Use kitchen twine to tie together the bay leaves, rosemary and thyme.\r\nMove the onions and garlic to the sides of the pot and nestle the brisket inside. Add the beef stock and the tied-up herbs. Bring the stock to a boil on the stovetop.\r\nCover the pot, place the pot in the 300°F oven and cook for 3 hours. Carefully flip the brisket every hour so it cooks evenly.\r\n \r\n5 Add carrots, continue to cook: After 3 hours, add the carrots. Cover the pot and cook for 1 hour more, or until the carrots are cooked through and the brisket is falling-apart tender.\r\n6 Remove brisket to cutting board, tent with foil: When the brisket is falling-apart tender, take the pot out of the oven and remove the brisket to a cutting board. Cover it with foil. Pull out and discard the herbs.\r\n7 Make sauce (optional): At this point you have two options. You can serve as is, or you can make a sauce with the drippings and some of the onions. If you serve as is, skip this step.\r\nTo make a sauce, remove the carrots and half of the onions, set aside and cover them with foil. Pour the ingredients that are remaining into the pot into a blender, and purée until smooth. If you want, add 1 tablespoon of mustard to the mix. Put into a small pot and keep warm.\r\n8 Slice the meat across the grain: Notice the lines of the muscle fibers of the roast. This is the "grain" of the meat. Slice the meat perpendicular to these lines, or across the grain (cutting this way further tenderizes the meat), in 1/4-inch to 1/2-inch slices.\r\nServe with the onions, carrots and gravy. Serve with mashed, roasted or boiled potatoes, egg noodles or polenta.',
      ingredients: [
        "Beef Brisket",
        "Salt",
        "Onion",
        "Garlic",
        "Thyme",
        "Rosemary",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.23",
      image:
        "https://www.themealdb.com/images/media/meals/ursuup1487348423.jpg",
    },
    {
      id: "52824",
      name: "Beef Sunday Roast",
      description:
        "Cook the Broccoli and Carrots in a pan of boiling water until tender.\r\n\r\nRoast the Beef and Potatoes in the oven for 45mins, the potatoes may need to be checked regularly to not overcook.\r\n\r\nTo make the Yorkshire puddings:\r\nHeat oven to 230C/fan 210C/gas 8. Drizzle a little sunflower oil evenly into 2 x 4-hole Yorkshire pudding tins or a 12-hole non-stick muffin tin and place in the oven to heat through\r\nTo make the batter, tip 140g plain flour into a bowl and beat in four eggs until smooth. Gradually add 200ml milk and carry on beating until the mix is completely lump-free. Season with salt and pepper. Pour the batter into a jug, then remove the hot tins from the oven. Carefully and evenly pour the batter into the holes. Place the tins back in the oven and leave undisturbed for 20-25 mins until the puddings have puffed up and browned. Serve immediately.\r\n\r\nPlate up and add the Gravy as desired.",
      ingredients: [
        "Beef",
        "Broccoli",
        "Potatoes",
        "Carrots",
        "plain flour",
        "Eggs",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.38",
      image:
        "https://www.themealdb.com/images/media/meals/ssrrrs1503664277.jpg",
    },
    {
      id: "52826",
      name: "Braised Beef Chilli",
      description:
        "Preheat the oven to 120C/225F/gas mark 1.\r\n\r\nTake the meat out of the fridge to de-chill. Pulse the onions and garlic in a food processor until finely chopped. Heat 2 tbsp olive oil in a large casserole and sear the meat on all sides until golden.\r\n\r\nSet to one side and add another small slug of oil to brown the chorizo. Remove and add the onion and garlic, spices, herbs and chillies then cook until soft in the chorizo oil. Season with salt and pepper and add the vinegar, tomatoes, ketchup and sugar.\r\n\r\nPut all the meat back into the pot with 400ml water (or red wine if you prefer), bring up to a simmer and cook, covered, in the low oven.\r\n\r\nAfter 2 hours, check the meat and add the beans. Cook for a further hour and just before serving, pull the meat apart with a pair of forks.",
      ingredients: [
        "Beef",
        "Onions",
        "Garlic",
        "Olive oil",
        "Chorizo",
        "Cumin",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.56",
      image:
        "https://www.themealdb.com/images/media/meals/uuqvwu1504629254.jpg",
    },
    {
      id: "52834",
      name: "Beef stroganoff",
      description:
        "Heat the olive oil in a non-stick frying pan then add the sliced onion and cook on a medium heat until completely softened, so around 15 mins, adding a little splash of water if they start to stick at all. Crush in the garlic and cook for a 2-3 mins further, then add the butter. Once the butter is foaming a little, add the mushrooms and cook for around 5 mins until completely softened. Season everything well, then tip onto a plate.\r\nTip the flour into a bowl with a big pinch of salt and pepper, then toss the steak in the seasoned flour. Add the steak pieces to the pan, splashing in a little oil if the pan looks particularly dry, and fry for 3-4 mins, until well coloured. Tip the onions and mushrooms back into the pan. Whisk the crème fraîche, mustard and beef stock together, then pour into the pan. Cook over a medium heat for around 5 mins. Scatter with parsley, then serve with pappardelle or rice.",
      ingredients: [
        "Olive Oil",
        "Onions",
        "Garlic",
        "Butter",
        "Mushrooms",
        "Beef Fillet",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.71",
      image:
        "https://www.themealdb.com/images/media/meals/svprys1511176755.jpg",
    },
    {
      id: "52842",
      name: "Broccoli & Stilton soup",
      description:
        "Heat the rapeseed oil in a large saucepan and then add the onions. Cook on a medium heat until soft. Add a splash of water if the onions start to catch.\r\n\r\nAdd the celery, leek, potato and a knob of butter. Stir until melted, then cover with a lid. Allow to sweat for 5 minutes. Remove the lid.\r\n\r\nPour in the stock and add any chunky bits of broccoli stalk. Cook for 10 – 15 minutes until all the vegetables are soft.\r\n\r\nAdd the rest of the broccoli and cook for a further 5 minutes. Carefully transfer to a blender and blitz until smooth. Stir in the stilton, allowing a few lumps to remain. Season with black pepper and serve.",
      ingredients: [
        "Rapeseed Oil",
        "Onion",
        "Celery",
        "Leek",
        "Potatoes",
        "Butter",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.03",
      image:
        "https://www.themealdb.com/images/media/meals/tvvxpv1511191952.jpg",
    },
    {
      id: "52848",
      name: "Bean & Sausage Hotpot",
      description:
        "In a large casserole, fry the sausages until brown all over – about 10 mins.\r\n\r\nAdd the tomato sauce, stirring well, then stir in the beans, treacle or sugar and mustard. Bring to the simmer, cover and cook for 30 mins. Great served with crusty bread or rice.",
      ingredients: [
        "Sausages",
        "Tomato Sauce",
        "Butter Beans",
        "Black Treacle",
        "English Mustard",
        "",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.85",
      image:
        "https://www.themealdb.com/images/media/meals/vxuyrx1511302687.jpg",
    },
    {
      id: "52855",
      name: "Banana Pancakes",
      description:
        "In a bowl, mash the banana with a fork until it resembles a thick purée. Stir in the eggs, baking powder and vanilla.\r\nHeat a large non-stick frying pan or pancake pan over a medium heat and brush with half the oil. Using half the batter, spoon two pancakes into the pan, cook for 1-2 mins each side, then tip onto a plate. Repeat the process with the remaining oil and batter. Top the pancakes with the pecans and raspberries.",
      ingredients: [
        "Banana",
        "Eggs",
        "Baking Powder",
        "Vanilla Extract",
        "Oil",
        "Pecan Nuts",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.71",
      image:
        "https://www.themealdb.com/images/media/meals/sywswr1511383814.jpg",
    },
    {
      id: "52873",
      name: "Beef Dumpling Stew",
      description:
        "Preheat the oven to 180C/350F/Gas 4.\r\n\r\nFor the beef stew, heat the oil and butter in an ovenproof casserole and fry the beef until browned on all sides.\r\n\r\nSprinkle over the flour and cook for a further 2-3 minutes.\r\n\r\nAdd the garlic and all the vegetables and fry for 1-2 minutes.\r\n\r\nStir in the wine, stock and herbs, then add the Worcestershire sauce and balsamic vinegar, to taste. Season with salt and freshly ground black pepper.\r\n\r\nCover with a lid, transfer to the oven and cook for about two hours, or until the meat is tender.\r\n\r\nFor the dumplings, sift the flour, baking powder and salt into a bowl.\r\nAdd the suet and enough water to form a thick dough.\r\n\r\nWith floured hands, roll spoonfuls of the dough into small balls.\r\n\r\nAfter two hours, remove the lid from the stew and place the balls on top of the stew. Cover, return to the oven and cook for a further 20 minutes, or until the dumplings have swollen and are tender. (If you prefer your dumplings with a golden top, leave the lid off when returning to the oven.)\r\n\r\nTo serve, place a spoonful of mashed potato onto each of four serving plates and top with the stew and dumplings. Sprinkle with chopped parsley.",
      ingredients: [
        "Olive Oil",
        "Butter",
        "Beef",
        "Plain Flour",
        "Garlic",
        "Onions",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.95",
      image:
        "https://www.themealdb.com/images/media/meals/uyqrrv1511553350.jpg",
    },
    {
      id: "52874",
      name: "Beef and Mustard Pie",
      description:
        "Preheat the oven to 150C/300F/Gas 2.\r\nToss the beef and flour together in a bowl with some salt and black pepper.\r\nHeat a large casserole until hot, add half of the rapeseed oil and enough of the beef to just cover the bottom of the casserole.\r\nFry until browned on each side, then remove and set aside. Repeat with the remaining oil and beef.\r\nReturn the beef to the pan, add the wine and cook until the volume of liquid has reduced by half, then add the stock, onion, carrots, thyme and mustard, and season well with salt and pepper.\r\nCover with a lid and place in the oven for two hours.\r\nRemove from the oven, check the seasoning and set aside to cool. Remove the thyme.\r\nWhen the beef is cool and you're ready to assemble the pie, preheat the oven to 200C/400F/Gas 6.\r\nTransfer the beef to a pie dish, brush the rim with the beaten egg yolks and lay the pastry over the top. Brush the top of the pastry with more beaten egg.\r\nTrim the pastry so there is just enough excess to crimp the edges, then place in the oven and bake for 30 minutes, or until the pastry is golden-brown and cooked through.\r\nFor the green beans, bring a saucepan of salted water to the boil, add the beans and cook for 4-5 minutes, or until just tender.\r\nDrain and toss with the butter, then season with black pepper.\r\nTo serve, place a large spoonful of pie onto each plate with some green beans alongside.",
      ingredients: [
        "Beef",
        "Plain Flour",
        "Rapeseed Oil",
        "Red Wine",
        "Beef Stock",
        "Onion",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.42",
      image:
        "https://www.themealdb.com/images/media/meals/sytuqu1511553755.jpg",
    },
    {
      id: "52878",
      name: "Beef and Oyster pie",
      description:
        "Season the beef cubes with salt and black pepper. Heat a tablespoon of oil in the frying pan and fry the meat over a high heat. Do this in three batches so that you don’t overcrowd the pan, transferring the meat to a large flameproof casserole dish once it is browned all over. Add extra oil if the pan seems dry.\r\nIn the same pan, add another tablespoon of oil and cook the shallots for 4-5 minutes, then add the garlic and fry for 30 seconds. Add the bacon and fry until slightly browned. Transfer the onion and bacon mixture to the casserole dish and add the herbs.\r\nPreheat the oven to 180C/350F/Gas 4.\r\nPour the stout into the frying pan and bring to the boil, stirring to lift any stuck-on browned bits from the bottom of the pan. Pour the stout over the beef in the casserole dish and add the stock. Cover the casserole and place it in the oven for 1½-2 hours, or until the beef is tender and the sauce is reduced.\r\nSkim off any surface fat, taste and add salt and pepper if necessary, then stir in the cornflour paste. Put the casserole dish on the hob – don’t forget that it will be hot – and simmer for 1-2 minutes, stirring, until thickened. Leave to cool.\r\nIncrease the oven to 200C/400F/Gas 6. To make the pastry, put the flour and salt in a very large bowl. Grate the butter and stir it into the flour in three batches. Gradually add 325ml/11fl oz cold water – you may not need it all – and stir with a round-bladed knife until the mixture just comes together. Knead the pastry lightly into a ball on a lightly floured surface and set aside 250g/9oz for the pie lid.\r\nRoll the rest of the pastry out until about 2cm/¾in larger than the dish you’re using. Line the dish with the pastry then pile in the filling, tucking the oysters in as well. Brush the edge of the pastry with beaten egg.\r\nRoll the remaining pastry until slightly larger than your dish and gently lift over the filling, pressing the edges firmly to seal, then trim with a sharp knife. Brush with beaten egg to glaze. Put the dish on a baking tray and bake for 25-30 minutes, or until the pastry is golden-brown and the filling is bubbling.",
      ingredients: [
        "Beef",
        "Olive Oil",
        "Shallots",
        "Garlic",
        "Bacon",
        "Thyme",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.86",
      image:
        "https://www.themealdb.com/images/media/meals/wrssvt1511556563.jpg",
    },
    {
      id: "52891",
      name: "Blackberry Fool",
      description:
        "For the biscuits, preheat the oven to 200C/180C (fan)/Gas 6 and line two large baking trays with baking parchment. Scatter the nuts over a baking tray and roast in the oven for 6-8 minutes, or until golden-brown. Watch them carefully so that they don’t have a chance to burn. Remove from the oven, tip onto a board and leave to cool.\r\nPut the butter and sugar in a large bowl and beat with a wooden spoon until light and creamy. Roughly chop the cooled nuts and add to the creamed butter and sugar, along with the lemon zest, flour and baking powder. Stir well until the mixture comes together and forms a ball – you may need to use your hands.\r\nDivide the biscuit dough into 24 even pieces and roll into small balls. Place the balls the prepared baking trays, spaced well apart to allow for spreading.\r\nPress the biscuits to flatten to around 1cm/½in thick. Bake the biscuits, one tray at a time, for 12 minutes or until very pale golden-brown. Leave to cool on the trays. They will be very soft when you take them out of the oven, but will crisp as they cool.\r\nStore in an airtight tin and eat within five days.\r\nFor the fool, rinse the blackberries in a colander to wash away any dust or dirt. Put the blackberries in a non-stick saucepan and sprinkle over the caster sugar.\r\nStir in the lemon juice and heat gently for two minutes, or until the blackberries begin to soften and release their juices. Remove and reserve 12 blackberries for decoration and continue cooking the rest.\r\nSimmer the blackberries very gently for 15 minutes, stirring regularly until very soft and squidgy. Remove from the heat and press the berries and juice through a sieve over a bowl, using the bottom of a ladle to help you extract as much of the purée as possible. Leave the purée to cool and discard the seeds. You should end up with around 325ml/11fl oz of purée.\r\nPut the cream and yoghurt in a large bowl and whip with an electric whisk until soft peaks form when the whisk is removed from the bowl – the acidity of the fruit will thicken the cream further, so don’t take it too far.\r\nWhen the purée is completely cold, adjust the sweetness to taste by adding more sugar if needed. Pour it into the bowl with the whipped cream and yoghurt and stir just once or twice until very lightly combined.\r\nSpoon the blackberry fool into individual wide, glass dishes – or one large, single bowl. It should look quite marbled, so don’t over-stir it. Scatter a few tiny mint leaves on top and decorate with the reserved blackberries. Sprinkle with a little sugar if you like and serve with the hazelnut biscuits.",
      ingredients: [
        "Hazlenuts",
        "Butter",
        "Caster Sugar",
        "Lemon",
        "Plain Flour",
        "Baking Powder",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.83",
      image:
        "https://www.themealdb.com/images/media/meals/rpvptu1511641092.jpg",
    },
    {
      id: "52894",
      name: "Battenberg Cake",
      description:
        "Heat oven to 180C/160C fan/gas 4 and line the base and sides of a 20cm square tin with baking parchment (the easiest way is to cross 2 x 20cm-long strips over the base). To make the almond sponge, put the butter, sugar, flour, ground almonds, baking powder, eggs, vanilla and almond extract in a large bowl. Beat with an electric whisk until the mix comes together smoothly. Scrape into the tin, spreading to the corners, and bake for 25-30 mins – when you poke in a skewer, it should come out clean. Cool in the tin for 10 mins, then transfer to a wire rack to finish cooling while you make the second sponge.\r\nFor the pink sponge, line the tin as above. Mix all the ingredients together as above, but don’t add the almond extract. Fold in some pink food colouring. Then scrape it all into the tin and bake as before. Cool.\r\nTo assemble, heat the jam in a small pan until runny, then sieve. Barely trim two opposite edges from the almond sponge, then well trim a third edge. Roughly measure the height of the sponge, then cutting from the well-trimmed edge, use a ruler to help you cut 4 slices each the same width as the sponge height. Discard or nibble leftover sponge. Repeat with pink cake.\r\nTake 2 x almond slices and 2 x pink slices and trim so they are all the same length. Roll out one marzipan block on a surface lightly dusted with icing sugar to just over 20cm wide, then keep rolling lengthways until the marzipan is roughly 0.5cm thick. Brush with apricot jam, then lay a pink and an almond slice side by side at one end of the marzipan, brushing jam in between to stick sponges, and leaving 4cm clear marzipan at the end. Brush more jam on top of the sponges, then sandwich remaining 2 slices on top, alternating colours to give a checkerboard effect. Trim the marzipan to the length of the cakes.\r\nCarefully lift up the marzipan and smooth over the cake with your hands, but leave a small marzipan fold along the bottom edge before you stick it to the first side. Trim opposite side to match size of fold, then crimp edges using fingers and thumb (or, more simply, press with prongs of fork). If you like, mark the 10 slices using the prongs of a fork.\r\nAssemble second Battenberg and keep in an airtight box or well wrapped in cling film for up to 3 days. Can be frozen for up to a month.",
      ingredients: [
        "Butter",
        "Caster Sugar",
        "Self-raising Flour",
        "Almonds",
        "Baking Powder",
        "Eggs",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.29",
      image:
        "https://www.themealdb.com/images/media/meals/ywwrsp1511720277.jpg",
    },
    {
      id: "52904",
      name: "Beef Bourguignon",
      description:
        "Heat a large casserole pan and add 1 tbsp goose fat. Season the beef and fry until golden brown, about 3-5 mins, then turn over and fry the other side until the meat is browned all over, adding more fat if necessary. Do this in 2-3 batches, transferring the meat to a colander set over a bowl when browned.\r\nIn the same pan, fry the bacon, shallots or pearl onions, mushrooms, garlic and bouquet garni until lightly browned. Mix in the tomato purée and cook for a few mins, stirring into the mixture. This enriches the bourguignon and makes a great base for the stew. Then return the beef and any drained juices to the pan and stir through.\r\nPour over the wine and about 100ml water so the meat bobs up from the liquid, but isn’t completely covered. Bring to the boil and use a spoon to scrape the caramelised cooking juices from the bottom of the pan – this will give the stew more flavour.\r\nHeat oven to 150C/fan 130C/gas 2. Make a cartouche: tear off a square of foil slightly larger than the casserole, arrange it in the pan so it covers the top of the stew and trim away any excess foil. Then cook for 3 hrs. If the sauce looks watery, remove the beef and veg with a slotted spoon, and set aside. Cook the sauce over a high heat for a few mins until the sauce has thickened a little, then return the beef and vegetables to the pan.\r\nTo make the celeriac mash, peel the celeriac and cut into cubes. Heat the olive oil in a large frying pan. Tip in the celeriac and fry for 5 mins until it turns golden. Season well with salt and pepper. Stir in the rosemary, thyme, bay and cardamom pods, then pour over 200ml water, enough to nearly cover the celeriac. Turn the heat to low, partially cover the pan and leave to simmer for 25-30 mins.\r\nAfter 25-30 mins, the celeriac should be soft and most of the water will have evaporated. Drain away any remaining water, then remove the herb sprigs, bay and cardamom pods. Lightly crush with a potato masher, then finish with a glug of olive oil and season to taste. Spoon the beef bourguignon into serving bowls and place a large spoonful of the celeriac mash on top. Garnish with one of the bay leaves, if you like.",
      ingredients: [
        "Goose Fat",
        "Beef Shin",
        "Bacon",
        "Challots",
        "Chestnut Mushroom",
        "Garlic Clove",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.99",
      image:
        "https://www.themealdb.com/images/media/meals/vtqxtu1511784197.jpg",
    },
    {
      id: "52913",
      name: "Brie wrapped in prosciutto & brioche",
      description:
        "Mix the flour, 1 tsp salt, caster sugar, yeast, milk and eggs together in a mixer using the dough attachment for 5 mins until the dough is smooth. Add the butter and mix for a further 4 mins on medium speed. Scrape the dough bowl and mix again for 1 min. Place the dough in a container, cover with cling film and leave in the fridge for at least 6 hrs before using.\r\nWrap the Brie in the prosciutto and set aside. Turn out the dough onto a lightly floured surface. Roll into a 25cm circle. Place the wrapped Brie in the middle of the circle and fold the edges in neatly. Put the parcel onto a baking tray lined with baking parchment and brush with beaten egg. Chill in the fridge for 30 mins, then brush again with beaten egg and chill for a further 30 mins. Leave to rise for 1 hr at room temperature. Heat oven to 200C/180C fan/gas 6, then bake for 22 mins. Serve warm.",
      ingredients: [
        "Plain Flour",
        "Caster Sugar",
        "Yeast",
        "Milk",
        "Eggs",
        "Eggs",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.35",
      image:
        "https://www.themealdb.com/images/media/meals/qqpwsy1511796276.jpg",
    },
    {
      id: "52914",
      name: "Boulangère Potatoes",
      description:
        "Heat oven to 200C/fan 180C/gas 6. Fry the onions and thyme sprigs in the oil until softened and lightly coloured (about 5 mins).\r\nSpread a layer of potatoes over the base of a 1.5-litre oiled gratin dish. Sprinkle over a few onions (see picture, above) and continue layering, finishing with a layer of potatoes. Pour over the stock and bake for 50-60 mins until the potatoes are cooked and the top is golden and crisp.",
      ingredients: [
        "Onions",
        "Thyme",
        "Olive Oil",
        "Potatoes",
        "Vegetable Stock",
        "",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.33",
      image:
        "https://www.themealdb.com/images/media/meals/qywups1511796761.jpg",
    },
    {
      id: "52928",
      name: "BeaverTails",
      description:
        "In the bowl of a stand mixer, add warm water, a big pinch of sugar and yeast. Allow to sit until frothy.\r\nInto the same bowl, add 1/2 cup sugar, warm milk, melted butter, eggs and salt, and whisk until combined.\r\nPlace a dough hook on the mixer, add the flour with the machine on, until a smooth but slightly sticky dough forms.\r\nPlace dough in a bowl, cover with plastic wrap, and allow to proof for 1 1/2 hours.\r\nCut dough into 12 pieces, and roll out into long oval-like shapes about 1/4 inch thick that resemble a beaver’s tail.\r\nIn a large, deep pot, heat oil to 350 degrees. Gently place beavertail dough into hot oil and cook for 30 to 45 seconds on each side until golden brown.\r\nDrain on paper towels, and garnish as desired. Toss in cinnamon sugar, in white sugar with a squeeze of lemon, or with a generous slathering of Nutella and a handful of toasted almonds. Enjoy!",
      ingredients: ["Water", "Yeast", "Sugar", "Milk", "Butter", "Eggs"],
      spicy: false,
      vegetarian: true,
      price: "11.00",
      image:
        "https://www.themealdb.com/images/media/meals/ryppsv1511815505.jpg",
    },
    {
      id: "52940",
      name: "Brown Stew Chicken",
      description:
        "Squeeze lime over chicken and rub well. Drain off excess lime juice.\r\nCombine tomato, scallion, onion, garlic, pepper, thyme, pimento and soy sauce in a large bowl with the chicken pieces. Cover and marinate at least one hour.\r\nHeat oil in a dutch pot or large saucepan. Shake off the seasonings as you remove each piece of chicken from the marinade. Reserve the marinade for sauce.\r\nLightly brown the chicken a few pieces at a time in very hot oil. Place browned chicken pieces on a plate to rest while you brown the remaining pieces.\r\nDrain off excess oil and return the chicken to the pan. Pour the marinade over the chicken and add the carrots. Stir and cook over medium heat for 10 minutes.\r\nMix flour and coconut milk and add to stew, stirring constantly. Turn heat down to minimum and cook another 20 minutes or until tender.",
      ingredients: [
        "Chicken",
        "Tomato",
        "Onions",
        "Garlic Clove",
        "Red Pepper",
        "Carrots",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.26",
      image:
        "https://www.themealdb.com/images/media/meals/sypxpx1515365095.jpg",
    },
    {
      id: "52952",
      name: "Beef Lo Mein",
      description:
        "STEP 1 - MARINATING THE BEEF\r\nIn a bowl, add the beef, salt, 1 pinch white pepper, 1 Teaspoon sesame seed oil, 1/2 egg, corn starch,1 Tablespoon of oil and mix together.\r\nSTEP 2 - BOILING THE THE NOODLES\r\nIn a 6 qt pot add your noodles to boiling water until the noodles are submerged and boil on high heat for 10 seconds. After your noodles is done boiling strain and cool with cold water.\r\nSTEP 3 - STIR FRY\r\nAdd 2 Tablespoons of oil, beef and cook on high heat untill beef is medium cooked.\r\nSet the cooked beef aside\r\nIn a wok add 2 Tablespoon of oil, onions, minced garlic, minced ginger, bean sprouts, mushrooms, peapods and 1.5 cups of water or until the vegetables are submerged in water.\r\nAdd the noodles to wok\r\nTo make the sauce, add oyster sauce, 1 pinch white pepper, 1 teaspoon sesame seed oil, sugar, and 1 Teaspoon of soy sauce.\r\nNext add the beef to wok and stir-fry",
      ingredients: [
        "Beef",
        "Salt",
        "Pepper",
        "Sesame Seed Oil",
        "Egg",
        "Starch",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.77",
      image: "https://www.themealdb.com/images/media/meals/1529444830.jpg",
    },
    {
      id: "52959",
      name: "Baked salmon with fennel & tomatoes",
      description:
        "Heat oven to 180C/fan 160C/gas 4. Trim the fronds from the fennel and set aside. Cut the fennel bulbs in half, then cut each half into 3 wedges. Cook in boiling salted water for 10 mins, then drain well. Chop the fennel fronds roughly, then mix with the parsley and lemon zest.\r\n\r\nSpread the drained fennel over a shallow ovenproof dish, then add the tomatoes. Drizzle with olive oil, then bake for 10 mins. Nestle the salmon among the veg, sprinkle with lemon juice, then bake 15 mins more until the fish is just cooked. Scatter over the parsley and serve.",
      ingredients: [
        "Fennel",
        "Parsley",
        "Lemon",
        "Cherry Tomatoes",
        "Olive Oil",
        "Salmon",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.37",
      image: "https://www.themealdb.com/images/media/meals/1548772327.jpg",
    },
    {
      id: "52961",
      name: "Budino Di Ricotta",
      description:
        "Mash the ricotta and beat well with the egg yolks, stir in the flour, sugar, cinnamon, grated lemon rind and the rum and mix well. You can do this in a food processor. Beat the egg whites until stiff, fold in and pour into a buttered and floured 25cm cake tin. Bake in the oven at 180ºC/160ºC fan/gas 4 for about 40 minutes, or until it is firm.\r\n\r\nServe hot or cold dusted with icing sugar.",
      ingredients: ["Ricotta", "Eggs", "Flour", "Sugar", "Cinnamon", "Lemons"],
      spicy: false,
      vegetarian: true,
      price: "10.77",
      image: "https://www.themealdb.com/images/media/meals/1549542877.jpg",
    },
    {
      id: "52965",
      name: "Breakfast Potatoes",
      description:
        "Before you do anything, freeze your bacon slices that way when you're ready to prep, it'll be so much easier to chop!\r\nWash the potatoes and cut medium dice into square pieces. To prevent any browning, place the already cut potatoes in a bowl filled with water.\r\nIn the meantime, heat 1-2 tablespoons of oil in a large skillet over medium-high heat. Tilt the skillet so the oil spreads evenly.\r\nOnce the oil is hot, drain the potatoes and add to the skillet. Season with salt, pepper, and Old Bay as needed.\r\nCook for 10 minutes, stirring the potatoes often, until brown. If needed, add a tablespoon more of oil.\r\nChop up the bacon and add to the potatoes. The bacon will start to render and the fat will begin to further cook the potatoes. Toss it up a bit! The bacon will take 5-6 minutes to crisp.\r\nOnce the bacon is cooked, reduce the heat to medium-low, add the minced garlic and toss. Season once more. Add dried or fresh parsley. Control heat as needed.\r\nLet the garlic cook until fragrant, about one minute.\r\nJust before serving, drizzle over the maple syrup and toss. Let that cook another minute, giving the potatoes a caramelized effect.\r\nServe in a warm bowl with a sunny side up egg!",
      ingredients: [
        "Potatoes",
        "Olive Oil",
        "Bacon",
        "Garlic Clove",
        "Maple Syrup",
        "Parsley",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.90",
      image: "https://www.themealdb.com/images/media/meals/1550441882.jpg",
    },
    {
      id: "52979",
      name: "Bitterballen (Dutch meatballs)",
      description:
        "Melt the butter in a skillet or pan. When melted, add the flour little by little and stir into a thick paste. Slowly stir in the stock, making sure the roux absorbs the liquid. Simmer for a couple of minutes on a low heat while you stir in the onion, parsley and the shredded meat. The mixture should thicken and turn into a heavy, thick sauce.\r\n\r\nPour the mixture into a shallow container, cover and refrigerate for several hours, or until the sauce has solidified.\r\n\r\nTake a heaping tablespoon of the cold, thick sauce and quickly roll it into a small ball. Roll lightly through the flour, then the egg and finally the breadcrumbs. Make sure that the egg covers the whole surface of the bitterbal. When done, refrigerate the snacks while the oil in your fryer heats up to 190C (375F). Fry four bitterballen at a time, until golden.\r\n\r\nServe on a plate with a nice grainy or spicy mustard. \r\n",
      ingredients: [
        "Butter",
        "Flour",
        "Beef Stock",
        "Onion",
        "Parsley",
        "Beef",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.05",
      image:
        "https://www.themealdb.com/images/media/meals/lhqev81565090111.jpg",
    },
    {
      id: "52995",
      name: "BBQ Pork Sloppy Joes",
      description:
        "1\r\n\r\nPreheat oven to 450 degrees. Wash and dry all produce. Cut sweet potatoes into ½-inch-thick wedges. Toss on a baking sheet with a drizzle of oil, salt, and pepper. Roast until browned and tender, 20-25 minutes.\r\n\r\n2\r\n\r\nMeanwhile, halve and peel onion. Slice as thinly as possible until you have ¼ cup (½ cup for 4 servings); finely chop remaining onion. Peel and finely chop garlic. Halve lime; squeeze juice into a small bowl. Halve buns. Add 1 TBSP butter (2 TBSP for 4) to a separate small microwave-safe bowl; microwave until melted, 30 seconds. Brush onto cut sides of buns.\r\n\r\n3\r\n\r\nTo bowl with lime juice, add sliced onion, ¼ tsp sugar (½ tsp for 4 servings), and a pinch of salt. Stir to combine; set aside to quick-pickle.\r\n\r\n4\r\n\r\nHeat a drizzle of oil in a large pan over medium-high heat. Add chopped onion and season with salt and pepper. Cook, stirring, until softened, 4-5 minutes. Add garlic and cook until fragrant, 30 seconds more. Add pork and season with salt and pepper. Cook, breaking up meat into pieces, until browned and cooked through, 4-6 minutes.\r\n\r\n5\r\n\r\nWhile pork cooks, in a third small bowl, combine BBQ sauce, pickling liquid from onion, 3 TBSP ketchup (6 TBSP for 4 servings), ½ tsp sugar (1 tsp for 4), and ¼ cup water (⅓ cup for 4). Once pork is cooked through, add BBQ sauce mixture to pan. Cook, stirring, until sauce is thickened, 2-3 minutes. Taste and season with salt and pepper.\r\n\r\n6\r\n\r\nMeanwhile, toast buns in oven or toaster oven until golden, 3-5 minutes. Divide toasted buns between plates and fill with as much BBQ pork as you’d like. Top with pickled onion and hot sauce. Serve with sweet potato wedges on the side.",
      ingredients: [
        "Potatoes",
        "Red Onions",
        "Garlic",
        "Lime",
        "Bread",
        "Pork",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.51",
      image:
        "https://www.themealdb.com/images/media/meals/atd5sh1583188467.jpg",
    },
    {
      id: "52997",
      name: "Beef Banh Mi Bowls with Sriracha Mayo, Carrot & Pickled Cucumber",
      description:
        "Add'l ingredients: mayonnaise, siracha\r\n\r\n1\r\n\r\nPlace rice in a fine-mesh sieve and rinse until water runs clear. Add to a small pot with 1 cup water (2 cups for 4 servings) and a pinch of salt. Bring to a boil, then cover and reduce heat to low. Cook until rice is tender, 15 minutes. Keep covered off heat for at least 10 minutes or until ready to serve.\r\n\r\n2\r\n\r\nMeanwhile, wash and dry all produce. Peel and finely chop garlic. Zest and quarter lime (for 4 servings, zest 1 lime and quarter both). Trim and halve cucumber lengthwise; thinly slice crosswise into half-moons. Halve, peel, and medium dice onion. Trim, peel, and grate carrot.\r\n\r\n3\r\n\r\nIn a medium bowl, combine cucumber, juice from half the lime, ¼ tsp sugar (½ tsp for 4 servings), and a pinch of salt. In a small bowl, combine mayonnaise, a pinch of garlic, a squeeze of lime juice, and as much sriracha as you’d like. Season with salt and pepper.\r\n\r\n4\r\n\r\nHeat a drizzle of oil in a large pan over medium-high heat. Add onion and cook, stirring, until softened, 4-5 minutes. Add beef, remaining garlic, and 2 tsp sugar (4 tsp for 4 servings). Cook, breaking up meat into pieces, until beef is browned and cooked through, 4-5 minutes. Stir in soy sauce. Turn off heat; taste and season with salt and pepper.\r\n\r\n5\r\n\r\nFluff rice with a fork; stir in lime zest and 1 TBSP butter. Divide rice between bowls. Arrange beef, grated carrot, and pickled cucumber on top. Top with a squeeze of lime juice. Drizzle with sriracha mayo.",
      ingredients: [
        "Rice",
        "Onion",
        "Lime",
        "Garlic Clove",
        "Cucumber",
        "Carrots",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.11",
      image:
        "https://www.themealdb.com/images/media/meals/z0ageb1583189517.jpg",
    },
    {
      id: "53013",
      name: "Big Mac",
      description:
        "For the Big Mac sauce, combine all the ingredients in a bowl, season with salt and chill until ready to use.\r\n2. To make the patties, season the mince with salt and pepper and form into 4 balls using about 1/3 cup mince each. Place each onto a square of baking paper and flatten to form into four x 15cm circles. Heat oil in a large frypan over high heat. In 2 batches, cook beef patties for 1-2 minutes each side until lightly charred and cooked through. Remove from heat and keep warm. Repeat with remaining two patties.\r\n3. Carefully slice each burger bun into three acrossways, then lightly toast.\r\n4. To assemble the burgers, spread a little Big Mac sauce over the bottom base. Top with some chopped onion, shredded lettuce, slice of cheese, beef patty and some pickle slices. Top with the middle bun layer, and spread with more Big Mac sauce, onion, lettuce, pickles, beef patty and then finish with more sauce. Top with burger lid to serve.\r\n5. After waiting half an hour for your food to settle, go for a jog.",
      ingredients: [
        "Minced Beef",
        "Olive Oil",
        "Sesame Seed Burger Buns",
        "Onion",
        "Iceberg Lettuce",
        "Cheese",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.81",
      image:
        "https://www.themealdb.com/images/media/meals/urzj1d1587670726.jpg",
    },
    {
      id: "53018",
      name: "Bigos (Hunters Stew)",
      description:
        "Preheat the oven to 350 degrees F (175 degrees C).\r\n\r\nHeat a large pot over medium heat. Add the bacon and kielbasa; cook and stir until the bacon has rendered its fat and sausage is lightly browned. Use a slotted spoon to remove the meat and transfer to a large casserole or Dutch oven.\r\n\r\nCoat the cubes of pork lightly with flour and fry them in the bacon drippings over medium-high heat until golden brown. Use a slotted spoon to transfer the pork to the casserole. Add the garlic, onion, carrots, fresh mushrooms, cabbage and sauerkraut. Reduce heat to medium; cook and stir until the carrots are soft, about 10 minutes. Do not let the vegetables brown.\r\n\r\nDeglaze the pan by pouring in the red wine and stirring to loosen all of the bits of food and flour that are stuck to the bottom. Season with the bay leaf, basil, marjoram, paprika, salt, pepper, caraway seeds and cayenne pepper; cook for 1 minute.\r\n\r\nMix in the dried mushrooms, hot pepper sauce, Worcestershire sauce, beef stock, tomato paste and tomatoes. Heat through just until boiling. Pour the vegetables and all of the liquid into the casserole dish with the meat. Cover with a lid.\r\n\r\nBake in the preheated oven for 2 1/2 to 3 hours, until meat is very tender.",
      ingredients: ["Bacon", "Kielbasa", "Pork", "Flour", "Garlic", "Onion"],
      spicy: false,
      vegetarian: true,
      price: "10.92",
      image:
        "https://www.themealdb.com/images/media/meals/md8w601593348504.jpg",
    },
    {
      id: "53036",
      name: "Boxty Breakfast",
      description:
        "STEP 1\r\nBefore you start, put your oven on its lowest setting, ready to keep things warm. Peel the potatoes, grate 2 of them, then set aside. Cut the other 2 into large chunks, then boil for 10-15 mins or until tender. Meanwhile, squeeze as much of the liquid from the grated potatoes as you can using a clean tea towel. Mash the boiled potatoes, then mix with the grated potato, spring onions and flour.\r\n\r\nSTEP 2\r\nWhisk the egg white in a large bowl until it holds soft peaks. Fold in the buttermilk, then add the bicarbonate of soda. Fold into the potato mix.\r\n\r\nSTEP 3\r\nHeat a large non-stick frying pan over a medium heat, then add 1 tbsp butter and some of the oil. Drop 3-4 spoonfuls of the potato mixture into the pan, then gently cook for 3-5 mins on each side until golden and crusty. Keep warm on a plate in the oven while you cook the next batch, adding more butter and oil to the pan before you do so. You will get 16 crumpet-size boxty from the mix. Can be made the day ahead, drained on kitchen paper, then reheated in a low oven for 20 mins.\r\n\r\nSTEP 4\r\nHeat the grill to medium and put the tomatoes in a heavy-based pan. Add a good knob of butter and a little oil, then fry for about 5 mins until softened. Grill the bacon, then pile onto a plate and keep warm. Stack up the boxty, bacon and egg, and serve the tomatoes on the side.",
      ingredients: [
        "Potatoes",
        "Spring Onions",
        "Plain Flour",
        "Egg White",
        "Milk",
        "Bicarbonate Of Soda",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.19",
      image:
        "https://www.themealdb.com/images/media/meals/naqyel1608588563.jpg",
    },
    {
      id: "53053",
      name: "Beef Rendang",
      description:
        "Chop the spice paste ingredients and then blend it in a food processor until fine.\r\nHeat the oil in a stew pot, add the spice paste, cinnamon, cloves, star anise, and cardamom and stir-fry until aromatic. Add the beef and the pounded lemongrass and stir for 1 minute. Add the coconut milk, tamarind juice, water, and simmer on medium heat, stirring frequently until the meat is almost cooked. Add the kaffir lime leaves, kerisik (toasted coconut), sugar or palm sugar, stirring to blend well with the meat.\r\nLower the heat to low, cover the lid, and simmer for 1 to 1 1/2 hours or until the meat is really tender and the gravy has dried up. Add more salt and sugar to taste. Serve immediately with steamed rice and save some for overnight.",
      ingredients: [
        "Beef",
        "Vegetable Oil",
        "Cinnamon Stick",
        "Cloves",
        "Star Anise",
        "Cardamom",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.78",
      image:
        "https://www.themealdb.com/images/media/meals/bc8v651619789840.jpg",
    },
    {
      id: "53060",
      name: "Burek",
      description:
        "Fry the finely chopped onions and minced meat in oil. Add the salt and pepper. Grease a round baking tray and put a layer of pastry in it. Cover with a thin layer of filling and cover this with another layer of filo pastry which must be well coated in oil. Put another layer of filling and cover with pastry. When you have five or six layers, cover with filo pastry, bake at 200ºC/392ºF for half an hour and cut in quarters and serve.",
      ingredients: [
        "Filo Pastry",
        "Minced Beef",
        "Onion",
        "Oil",
        "Salt",
        "Pepper",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.82",
      image:
        "https://www.themealdb.com/images/media/meals/tkxquw1628771028.jpg",
    },
    {
      id: "53068",
      name: "Beef Mechado",
      description:
        "0.\tMake the beef tenderloin marinade by combining soy sauce, vinegar, ginger, garlic, sesame oil, olive oil, sugar, salt, and ground black pepper in a large bowl. Mix well.\r\n1.\tAdd the cubed beef tenderloin to the bowl with the beef tenderloin marinade. Gently toss to coat the beef. Let it stay for 1 hour.\r\n2.\tUsing a metal or bamboo skewer, assemble the beef kebob by skewering the vegetables and marinated beef tenderloin.\r\n3.\tHeat-up the grill and start grilling the beef kebobs for 3 minutes per side. This will give you a medium beef that is juicy and tender on the inside. Add more time if you want your beef well done, but it will be less tender.\r\n4.\tTransfer to a serving plate. Serve with Saffron rice.\r\n5.\tShare and enjoy!\r\n",
      ingredients: [
        "Garlic",
        "Onion",
        "Beef",
        "Tomato Puree",
        "Water",
        "Olive Oil",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.02",
      image:
        "https://www.themealdb.com/images/media/meals/cgl60b1683206581.jpg",
    },
    {
      id: "53069",
      name: "Bistek",
      description:
        "0.\tMarinate beef in soy sauce, lemon (or calamansi), and ground black pepper for at least 1 hour. Note: marinate overnight for best result\r\n1.\tHeat the cooking oil in a pan then pan-fry half of the onions until the texture becomes soft. Set aside\r\n2.\tDrain the marinade from the beef. Set it aside. Pan-fry the beef on the same pan where the onions were fried for 1 minute per side. Remove from the pan. Set aside\r\n3.\tAdd more oil if needed. Saute garlic and remaining raw onions until onion softens.\r\n4.\tPour the remaining marinade and water. Bring to a boil.\r\n5.\tAdd beef. Cover the pan and simmer until the meat is tender. Note: Add water as needed.\r\n6.\tSeason with ground black pepper and salt as needed. Top with pan-fried onions.\r\n7.\tTransfer to a serving plate. Serve hot. Share and Enjoy!\r\n",
      ingredients: [
        "Beef",
        "Soy Sauce",
        "Lemon",
        "Garlic",
        "Onion",
        "Olive Oil",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.83",
      image:
        "https://www.themealdb.com/images/media/meals/4pqimk1683207418.jpg",
    },
    {
      id: "53070",
      name: "Beef Caldereta",
      description:
        "0.\tHeat oil in a cooking pot. Saute onion and garlic until onion softens\r\n1.\tAdd beef. Saute until the outer part turns light brown.\r\n2.\tAdd soy sauce. Pour tomato sauce and water. Let boil.\r\n3.\tAdd Knorr Beef Cube. Cover the pressure cooker. Cook for 30 minutes.\r\n4.\tPan-fry carrot and potato until it browns. Set aside.\r\n5.\tAdd chili pepper, liver spread and peanut butter. Stir.\r\n6.\tAdd bell peppers, fried potato and carrot. Cover the pot. Continue cooking for 5 to 7 minutes.\r\n7.\tSeason with salt and ground black pepper. Serve.\r\n",
      ingredients: [
        "Beef",
        "Beef Stock",
        "Soy Sauce",
        "Water",
        "Green Pepper",
        "Red Pepper",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.59",
      image:
        "https://www.themealdb.com/images/media/meals/41cxjh1683207682.jpg",
    },
    {
      id: "53071",
      name: "Beef Asado",
      description:
        "0.\tCombine beef, crushed peppercorn, soy sauce, vinegar, dried bay leaves, lemon, and tomato sauce. Mix well. Marinate beef for at least 30 minutes.\r\n1.\tPut the marinated beef in a cooking pot along with remaining marinade. Add water. Let boil.\r\n2.\tAdd Knorr Beef Cube. Stir. Cover the pot and cook for 40 minutes in low heat.\r\n3.\tTurn the beef over. Add tomato paste. Continue cooking until beef tenderizes. Set aside.\r\n4.\tHeat oil in a pan. Fry the potato until it browns. Turn over and continue frying the opposite side. Remove from the pan and place on a clean plate. Do the same with the carrots.\r\n5.\tSave 3 tablespoons of cooking oil from the pan where the potato was fried. Saute onion and garlic until onion softens.\r\n6.\tPour-in the sauce from the beef stew. Let boil. Add the beef. Cook for 2 minutes.\r\n7.\tAdd butter and let it melt. Continue cooking until the sauce reduces to half.",
      ingredients: [
        "Beef",
        "Beef Stock Concentrate",
        "Tomato Puree",
        "Water",
        "Soy Sauce",
        "White Wine Vinegar",
      ],
      spicy: false,
      vegetarian: true,
      price: "10.53",
      image:
        "https://www.themealdb.com/images/media/meals/pkopc31683207947.jpg",
    },
  ],
};

export const TABLE_DATA = [
  {
    type: "Bar",
    time: "6:30 PM",
  },
  {
    type: "Counter",
    time: "6:30 PM",
  },
  {
    type: "High Top",
    time: "7:00 PM",
  },
  {
    type: "Standard",
    time: "Unavailable",
  },
];
